import React  from 'react'
import { Container, Grid, Typography } from '@mui/material'
import styles from './styles'

const TermsAndConditions = () => {

  const renderStandardTermsAndConditions = () => {
    return (
      <Grid style={styles.container}>
        <h1 style={styles.headers}>STANDARD TERMS AND CONDITIONS</h1>
        <Typography style={styles.paragraph}>
          These Standard Terms and Conditions for 360 Media Direct, LLC., are
          intended to offer media companies and advertising agencies a
          standard for conducting business in a manner acceptable to both.
          This document, when incorporated into an insertion order, represents
          the parties’ common understanding for doing business. This
          document may not fully cover sponsorships and other arrangements
          involving content association or integration, and/or special
          production, but may be used as the basis for the media components
          of such contracts. This document is not meant to cover the
          relationship between a publisher and a network, or direct Company
          buys with publishers.
        </Typography>
      </Grid>
    )
  }

  const renderDefinitions = () => {
    return (
      <Grid style={styles.container}>
        <h1 style={styles.headers}>DEFINITIONS</h1>
        <Typography style={styles.paragraph}>
          <span style={styles.bold}>“Ad”</span> means any advertisement provided by 360 Media Direct on
          behalf of an Company. <span style={styles.bold}>“Company”</span> means the Company for which
          360 Media Direct is the agent under an applicable IO.
          <span style={styles.bold}> “Advertising Materials”</span> means artwork, copy, or active URLs for Ads.
          <span style={styles.bold}> “Affiliate”</span> means, as to an entity, any other entity directly or
          indirectly controlling, controlled by, or under common control with,
          such entity.
          <span style={styles.bold}> “360 Media Direct”</span> means the 360 Media Direct and/or one of its
          affiliates or subsidiaries as listed on the applicable IO.
          <span style={styles.bold}> “IO”</span> means a mutually agreed insertion order that incorporates these
          Terms, under which Company will deliver Ads or other products as

          described in the applicable I/O on Sites for the benefit of 360 Media
          Direct or Company.
          <span style={styles.bold}> “Company”</span> means the company listed on the applicable IO.
          <span style={styles.bold}> “Company Properties”</span> are websites specified on an IO that are
          owned, operated, or controlled by Company.
          <span style={styles.bold}> “Network Properties”</span> means websites specified on an IO that are
          not owned, operated, or controlled by Company, but on which
          Company has a contractual right to serve Ads.
          <span style={styles.bold}> “Policies”</span> means advertising criteria or specifications made
          conspicuously available, including content limitations, technical
          specifications, privacy policies, user experience policies, policies
          regarding consistency with Company’s public image, community
          standards regarding obscenity or indecency (taking into consideration
          the portion(s) of the Site on which the Ads are to appear), other
          editorial or advertising policies, and Advertising Materials due dates.
          <span style={styles.bold}> “Representative”</span> means, as to an entity and/or its Affiliate(s), any
          director, officer, employee, consultant, contractor, agent, and/or
          attorney.
          <span style={styles.bold}> “Site”</span> or <span style={styles.bold}>“Sites”</span> means Company Properties and Network Properties.
          <span style={styles.bold}> “Terms”</span> means these Standard Terms and Conditions.

          <ol type={"I"}>
            <li style={styles.list}>
              <span style={styles.bold}>INSERTION ORDERS DETAILS</span>
              <ol type={"A"}>
                <li>
                  <span style={styles.underline}>IO Details.</span> From time to time, Company and 360 Media Direct may execute IOs that will be
                  accepted as set forth in Section I(b). As applicable, each IO will specify: (i) the type(s) and
                  amount(s) of Deliverables, (ii) the price(s) for such Deliverables, (iii) the maximum amount of
                  money to be spent pursuant to the IO, (iv) the start and end dates of the campaign. Other
                  items that may be included are, but are not limited to, reporting requirements, and
                  specifications concerning ownership of data collected.
                </li>
                <li>
                  <span style={styles.underline}>Availability;</span> Acceptance. Company will make commercially reasonable efforts to notify 360
                  Media Direct within two (2) business days of receipt of an IO signed by 360 Media Direct if
                  the specified inventory is not available. Acceptance of the IO and these Terms will be
                  deemed the earlier of (i) written (which, unless otherwise specified, for purposes of these
                  Terms, will include paper, fax, or e-mail communication) approval of the IO by Company and
                  360 Media Direct, unless otherwise agreed on the IO. Notwithstanding the foregoing,
                  modifications to the originally submitted IO will not be binding unless approved in writing by
                  both Company and 360 Media Direct.
                </li>
                <li>
                  <span style={styles.underline}>Revisions.</span> Revisions to accepted IOs will be made in writing and acknowledged by the other
                  party in writing.
                </li>
              </ol>
            </li>
            <li style={styles.list}>
              <span style={styles.bold}>PAYMENT</span>
              <ol type={"A"}>
                <li>
                  <span style={styles.underline}>Payment Date.</span> Company will make payment within 5 business day of IO being fully
                  executed, unless otherwise stated in a payment schedule set forth on the IO.
                </li>
              </ol>
            </li>

            <li style={styles.list}>
              <span style={styles.bold}>CANCELLATION AND TERMINATION</span>
              <ol type={"A"}>
                <li>
                  <span style={styles.underline}>Without Cause.</span> Unless designated on the IO as non-cancelable, 360 Media Direct or
                  Company may cancel the IO for any reason with 14 days written notice, which may include
                  electronic mail.
                </li>
                <li>
                  <span style={styles.underline}>For Cause.</span> Either Company or 360 Media Direct may terminate an IO at any time if the other
                  party is in material breach of its obligations hereunder, which breach is not cured within 5
                  days after receipt of written notice thereof from the non-breaching party, except as
                  otherwise stated in these Terms with regard to specific breaches.
                </li>
              </ol>
            </li>

            <li style={styles.list}>
              <span style={styles.bold}>FORCE MAJEURE</span>
              <ol type={"A"}>
                <li>
                  <span style={styles.underline}>Generally.</span> Excluding payment obligations, neither 360 Media Direct nor Company will be
                  liable for delay or default in the performance of its respective obligations under these Terms
                  if such delay or default is caused by conditions beyond its reasonable control, including, but
                  not limited to, fire, flood, accident, earthquakes, telecommunications line failures, electrical
                  outages, network failures, acts of God, or labor disputes (“Force Majeure event”). If Company
                  suffers such a delay or default, Company will make reasonable efforts within five (5)
                  business days to recommend a substitute transmission for the Ad or time period for the
                  transmission. If no such substitute time period or makegood is reasonably acceptable to 360
                  Media Direct, Company will allow 360 Media Direct a pro rata reduction in the space, time,
                  and/or program charges hereunder in the amount of money assigned to the space, time,
                  and/or program charges at time of purchase. In addition, 360 Media Direct will have the
                  benefit of the same discounts that would have been earned had there been no default or
                  delay.
                </li>
                <li>
                  <span style={styles.underline}>Related to Payment.</span> If Company’s ability to transfer funds to 360 Media Direct has been
                  materially negatively impacted by an event beyond the Company’s reasonable control,
                  including, but not limited to, failure of banking clearing systems or a state of emergency,
                  then Company will make every reasonable effort to make payments on a timely basis to 360
                  Media Direct, but any delays caused by such condition will be excused for the duration of
                  such condition. Subject to the foregoing, such excuse for delay will not in any way relieve
                  Company from any of its obligations as to the amount of money that would have been due
                  and paid without such condition.
                </li>
                <li>
                  <span style={styles.underline}>Cancellation.</span> If a Force Majeure event has continued for five (5) business days, Company
                  and/or 360 Media Direct has the right to cancel the remainder of the IO without penalty.
                </li>
              </ol>
            </li>

            <li style={styles.list}>
              <span style={styles.bold}>INDEMNIFICATION</span>
              <ol type={"A"}>
                <li>
                  <span style={styles.underline}>By Company.</span> Company will defend, indemnify, and hold harmless 360 Media Direct and
                  each of its Affiliates and Representatives from Losses resulting from any Claims brought by
                  a Third Party resulting from (i) Company’s alleged breach of any Section of this Agreement,
                  (ii) Company’s violation of Policies (to the extent the terms of such Policies have been
                  provided (e.g., by making such Policies available by providing a URL) via email or other
                  affirmative means, to 360 Media Direct or Company at least 14 days prior to the violation
                  giving rise to the Claim), (iii) for any damages arising out of Company, or Company’s agents,
                  employees, or Affiliates negligent action or inaction., or (iv) for any violation by Company of
                  the California Consumer Privacy Act (the “CCPA”), the Canada Consumer Privacy Protection
                  Act (“CPPA”), the Canada Anti-Spam Legislation (“CASL”) or the European Union’s General
                  Data Protection Regulation (“GDPR”).
                </li>
                <li>
                  <span style={styles.underline}>Procedure.</span> The indemnified party(s) will promptly notify the indemnifying party of all Claims
                  of which it becomes aware (provided that a failure or delay in providing such notice will not
                  relieve the indemnifying party’s obligations except to the extent such party is prejudiced by

                  such failure or delay), and will: (i) provide reasonable cooperation to the indemnifying party
                  at the indemnifying party’s expense in connection with the defense or settlement of all
                  Claims; and (ii) be entitled to participate at its own expense in the defense of all Claims. The
                  indemnified party(s) agrees that the indemnifying party will have sole and exclusive control
                  over the defense and settlement of all Claims; provided, however, the indemnifying party
                  will not acquiesce to any judgment or enter into any settlement, either of which imposes any
                  obligation or liability on an indemnified party(s) without its prior written consent.
                </li>
              </ol>
            </li>

            <li style={styles.list}>
              <span style={styles.bold}>LIMITATION OF LIABILITY</span>
              <ol type={"A"}>
                <li>
                  Excluding 360 Media Direct’s, Company’s, and Company’s respective obligations under
                  Section V, damages that result from a breach of Section VII, or intentional misconduct by 360
                  Media Direct or Company, in no event will any party be liable for any consequential, indirect,
                  incidental, punitive, special, or exemplary damages whatsoever, including, but not limited to,
                  damages for loss of profits, business interruption, loss of information, and the like, incurred
                  by another party arising out of an IO, even if such party has been advised of the possibility of
                  such damages.
                </li>
              </ol>
            </li>

            <li style={styles.list}>
              <span style={styles.bold}>NON-DISCLOSURE, DATA USAGE AND OWNERSHIP, PRIVACY AND LAWS</span>
              <ol type={"A"}>
                <li>
                  <span style={styles.underline}>Definitions and Obligations.</span> “Confidential Information” will include (i) all information marked
                  as “Confidential,” “Proprietary,” or similar legend by the disclosing party (“Discloser”) when
                  given to the receiving party (“Recipient”); and (ii) information and data provided by the
                  Discloser, which under the circumstances surrounding the disclosure should be reasonably
                  deemed confidential or proprietary. Without limiting the foregoing, Discloser and Recipient
                  agree that each Discloser’s contribution to IO Details (as defined below) shall be considered
                  such Discloser’s Confidential Information. Recipient will protect Confidential Information in
                  the same manner that it protects its own information of a similar nature, but in no event with
                  less than reasonable care. Recipient shall not disclose Confidential Information to anyone
                  except an employee, agent, Affiliate, or third party who has a need to know same, and who is
                  bound by confidentiality and non-use obligations at least as protective of Confidential
                  Information as are those in this section. Recipient will not use Discloser’s Confidential
                  Information other than as provided for on the IO.
                </li>
                <li>
                  <span style={styles.underline}>Exceptions.</span> Notwithstanding anything contained herein to the contrary, the term
                  “Confidential Information” will not include information which: (i) was previously known to
                  Recipient; (ii) was or becomes generally available to the public through no fault of Recipient;
                  (iii) was rightfully in Recipient’s possession free of any obligation of confidentiality at, or prior
                  to, the time it was communicated to Recipient by Discloser; (iv) was developed by employees
                  or agents of Recipient independently of, and without reference to, Confidential Information;
                  or (v) was communicated by Discloser to an unaffiliated third party free of any obligation of
                  confidentiality. Notwithstanding the foregoing, the Recipient may disclose Confidential
                  Information of the Discloser in response to a valid order by a court or other governmental
                  body, as otherwise required by law or the rules of any applicable securities exchange, or as
                  necessary to establish the rights of either party under these Terms; provided, however, that
                  both Discloser and Recipient will stipulate to any orders necessary to protect such
                  information from public disclosure.
                </li>
                <li>
                  <span style={styles.underline}>Additional Definitions.</span> As used herein the following terms shall have the following
                  definitions:
                  <ol type={"I"}>
                    <li>
                      <span style={styles.bold}>“User Volunteered Data”</span> is personally identifiable information collected from
                      individual users by Company during delivery of an Ad pursuant to the IO, but only
                      where it is expressly disclosed to such individual users that such collection is solely
                      on behalf of Company.
                    </li>
                    <li>
                      <span style={styles.bold}>“IO Details”</span> are details set forth on the IO but only when expressly associated with
                      the applicable Discloser, including, but not limited to, Ad pricing information, Ad
                      description, Ad placement information, and Ad targeting information.
                    </li>
                    <li>
                      <span style={styles.bold}>“Performance Data”</span> is data regarding a campaign gathered during delivery of an Ad
                      pursuant to the IO (e.g., number of impressions, interactions, and header
                      information), but excluding Site Data or IO Details.
                    </li>
                    <li>
                      <span style={styles.bold}>“Site Data”</span> is any data that is (A) preexisting Company data used by Company
                      pursuant to the IO; (B) gathered pursuant to the IO during delivery of an Ad that
                      identifies or allows identification of Company, Company’s Site, brand, content,
                      context, or users as such; or (C) entered by users on any Company Site other than
                      User Volunteered Data.
                    </li>
                    <li>
                      <span style={styles.bold}>“Collected Data”</span> consists of IO Details, Performance Data, and Site Data.
                    </li>
                    <li>
                      <span style={styles.bold}>“Repurposing”</span> means retargeting a user or appending data to a non-public profile
                      regarding a user for purposes other than performance of the IO.
                    </li>
                    <li>
                      <span style={styles.bold}>“Aggregated”</span> means a form in which data gathered under an IO is combined with
                      data from numerous campaigns of numerous Company’s and precludes
                      identification, directly or indirectly, of an Company.
                    </li>
                  </ol>
                </li>
                <li>
                  <span style={styles.underline}>Use of Collected Data.</span>
                  <ol type={"I"}>
                    <li>
                      Unless otherwise authorized by Company, Company will not: (A) use Collected Data
                      for Repurposing; provided, however, that Performance Data may be used for
                      Repurposing so long as it is not joined with any IO Details or Site Data; (B) disclose
                      IO Details of Company or Site Data to any Affiliate or Third Party except as set forth
                      in Section XII(d)(iii).
                    </li>
                    <li>
                      Unless otherwise authorized by 360 Media Direct or Company, Company will not:
                      (A) use or disclose IO Details of Company, Performance Data, or a user’s recorded
                      view or click of an Ad, each of the foregoing on a non-Aggregated basis, for
                      Repurposing or any purpose other than performing under the IO, compensating data
                      providers in a way that precludes identification of the Company, or internal reporting
                      or internal analysis; or (B) use or disclose any User Volunteered Data in any manner
                      other than in performing under the IO.
                    </li>
                  </ol>
                </li>
                <li>
                  <span style={styles.underline}>User Volunteered Data.</span> All User Volunteered Data is the property of Company, is subject to
                  the Company’s posted privacy policy and is considered Confidential Information of Company.
                  Any other use of such information will be set forth on the IO and signed by both parties.
                </li>
                <li>
                  <span style={styles.underline}>Privacy Policies.</span> 360 Media Direct, Company, and Company will post on their respective
                  Web sites their privacy policies and adhere to their privacy policies, which will abide by
                  applicable laws. Failure by Company, on the one hand, or 360 Media Direct or Company, on
                  the other, to continue to post a privacy policy, or non-adherence to such privacy policy, is
                  grounds for immediate cancellation of the IO by the other party.
                </li>
                <li>
                  <span style={styles.underline}>Compliance with Law.</span> 360 Media Direct, Company, and Company will always comply with
                  all federal, state, and local laws, ordinances, regulations, and codes which are applicable to
                  their performance of their respective obligations under the IO.
                </li>
                <li>
                  360 Media Direct Use of Data. 360 Media Direct will not: (i) use Collected Data unless
                  Company is permitted to use such Collected Data, nor (ii) use Collected Data in ways that
                  Company is not allowed to use such Collected Data. Notwithstanding the foregoing or
                  anything to the contrary herein, the restrictions on Company in Section XII(d)(i) shall not
                  prohibit 360 Media Direct from (A) using Collected Data on an Aggregated basis for internal
                  media planning purposes only (but not for Repurposing), or (B) disclosing qualitative
                  evaluations of Aggregated Collected Data to its clients and potential clients, and Media
                  Companies on behalf of such clients or potential clients, for the purpose of media planning.
                </li>
                <li>
                  Notwithstanding the foregoing, in no event shall Company or Media 360 use any data or
                  personal information received as a result of these Terms or the I/O in any manner which
                  gives rise to liability for violation of the CCPA, CPPA, the CASL or the GDPR.
                </li>
              </ol>
            </li>

            <li style={styles.list}>
              <span style={styles.bold}>MISCELLANEOUS</span>
              <ol type={"A"}>
                <li>
                  Necessary Rights. Company represents and warrants that Company has all necessary
                  permits, licenses, and clearances to sell the Deliverables specified on the IO subject to these
                  Terms. Company represents and warrants that Company has all necessary licenses and
                  clearances to use the content contained in the Ads and Advertising Materials as specified on
                  the IO and subject to these Terms, including any applicable Policies.
                </li>
                <li>
                  <span style={styles.underline}>Assignment.</span> Neither 360 Media Direct nor Company may resell, assign, or transfer any of its
                  rights or obligations hereunder, and any attempt to resell, assign, or transfer such rights or
                  obligations without Company’s prior written approval will be null and void. All terms and
                  conditions in these Terms and each IO will be binding upon and inure to the benefit of the
                  parties hereto and their respective permitted transferees, successors, and assigns.
                </li>
                <li>
                  <span style={styles.underline}>Entire Agreement.</span> Each IO (including the Terms) will constitute the entire agreement of the
                  parties with respect to the subject matter thereof and supersede all previous
                  communications, representations, understandings, and agreements, either oral or written,
                  between the parties with respect to the subject matter of the IO. The IO may be executed in
                  counterparts, each of which will be an original, and all of which together will constitute one
                  and the same document.
                </li>
                <li>
                  <span style={styles.underline}>Conflicts; Governing Law; Amendment.</span> In the event of any inconsistency between the terms
                  of an IO and these Terms, the terms of the IO will prevail. All IOs will be governed by the
                  laws of the State of California. Company and 360 Media Direct (on behalf of itself and
                  Company) agree that any claims, legal proceedings, or litigation arising in connection with
                  the IO (including these Terms) will be brought solely in the federal and state courts sitting in
                  Fresno County, California, and the parties’ consent to the jurisdiction of such courts
                  regardless of any conflicts of law.
                </li>
                <li>
                  No modification of these Terms will be binding unless in writing and signed by both parties.
                  If any provision herein is held to be unenforceable, the remaining provisions will remain in
                  full force and effect. All rights and remedies hereunder are cumulative.
                </li>
                <li>
                  Notice. Any notice required to be delivered hereunder will be deemed delivered three days
                  after deposit, postage paid, in U.S. mail, return receipt requested, one business day if sent by
                  overnight courier service, and immediately if sent electronically or by fax. All notices to
                  Company and 360 Media Direct will be sent to the contact as noted on the IO with a copy to
                  the Legal Department. All notices to Company will be sent to the address specified on the
                  IO.
                </li>
                <li>
                  <span style={styles.underline}>Survival.</span> Sections III, VI, X, XI, XII, and XIV will survive termination or expiration of these
                  Terms, and Section IV will survive for 30 days after the termination or expiration of these
                  Terms. In addition, each party will promptly return or destroy the other party’s Confidential
                  Information upon written request and remove Advertising Materials and Ad tags upon
                  termination of these Terms.
                </li>
                <li>
                  <span style={styles.underline}>Headings.</span> Section or paragraph headings used in these Terms are for reference purposes
                  only and should not be used in the interpretation hereof.
                </li>
              </ol>
            </li>

          </ol>
        </Typography>
      </Grid>
    )
  }


  return (
    <Container style={{ maxWidth: 1200, padding: 50, display: 'flex', flexDirection: 'column', gap: 75 }}>
      {renderStandardTermsAndConditions()}
      {renderDefinitions()}
    </Container>
  )
}

export default TermsAndConditions

